import React, { useEffect, useState, useMemo } from 'react';
import Container from '../../../Container/Container'
import { useNavigate, useLocation, Link } from 'react-router';
import { useForm, Controller } from "react-hook-form";
import { get, ImageUrl } from '../../../ApiServices/ApiServices';
import Select from 'react-select';
import 'react-toastify/dist/ReactToastify.css';
import { Image } from 'antd';
import { useDispatch, useSelector } from 'react-redux';

import { Search } from "lucide-react";

function GroomsmenStyleDetail({ onSubmit, onNext, onBack, ticket, initialValues }) {
    // Initialize form with values from localStorage if initialValues is empty
    const getInitialFormValues = () => {
        if (initialValues && Object.keys(initialValues).length > 0) {
            return initialValues;
        }

        // Fallback to localStorage if no initialValues provided
        const coatStyle = JSON.parse(localStorage.getItem('GroomMencoatStyle'));
        const pantstyle = JSON.parse(localStorage.getItem('GroomMenpantstyle'));
        const shirtstyle = JSON.parse(localStorage.getItem('GroomMenshirtstyle'));
        const Veststyle = JSON.parse(localStorage.getItem('GroomMenVeststyle'));
        const Shoesstyle = JSON.parse(localStorage.getItem('GroomMenshoestyle'));

        return {
            GroomMenCoat: coatStyle?.style || '',
            GroomMenPant: pantstyle?.style || '',
            GroomMenShirt: shirtstyle?.style || '',
            GroomMenVest: Veststyle?.style || '',
            GroomMenShoes: Shoesstyle?.style || '',
            GroomMenTie: '',
            GroomMenPocket: '',
            GroomMenJewelry: '',
            GroomMencoatinventory_id: coatStyle?.id || '',
            GroomMenPaintinventory_id: pantstyle?.id || '',
            GroomMenshirtInventory_id: shirtstyle?.id || '',
            GroomMenVestInventory_id: Veststyle?.id || '',
            GroomMenShoesInventory_id: Shoesstyle?.id || '',
            GroomMenTieInventory_id: '',
            GroomMenPocketInventory_id: '',
            GroomMenjewelryinventory_id: ''
        };
    };

    const { register, handleSubmit, formState: { errors }, control, watch, getValues, trigger, setValue } = useForm({
        defaultValues: getInitialFormValues()
    });

    const [data, setdata] = useState([])

    // Initialize from localStorage or initialValues with full item data
    const getInitialStyleState = () => {
        const coatStyle = JSON.parse(localStorage.getItem('GroomMencoatStyle'));
        const pantstyle = JSON.parse(localStorage.getItem('GroomMenpantstyle'));
        const shirtstyle = JSON.parse(localStorage.getItem('GroomMenshirtstyle'));
        const Veststyle = JSON.parse(localStorage.getItem('GroomMenVeststyle'));
        const Shoesstyle = JSON.parse(localStorage.getItem('GroomMenshoestyle'));

        return {
            coat: coatStyle,
            pant: pantstyle,
            shirt: shirtstyle,
            vest: Veststyle,
            shoes: Shoesstyle
        };
    };

    const initialStyles = getInitialStyleState();

    const [Coatstyle, setCoatstyle] = useState(initialStyles.coat)
    const [Pantstyle, setPantstyle] = useState(initialStyles.pant)
    const [Shirtstyle, setShirtstyle] = useState(initialStyles.shirt)
    const [Veststyle, setVeststyle] = useState(initialStyles.vest)
    const [Shoesstyle, setShoesstyle] = useState(initialStyles.shoes);
    const [selectedCoatStyleForPants, setSelectedCoatStyleForPants] = useState(initialStyles.coat?.style || null);
    const selectedShoesStyle = watch("GroomMenShoes");

    const [LebelCoat, setLebelCoat] = useState(initialStyles.coat)
    const [Lebelpant, setLebelpant] = useState(initialStyles.pant)
    const [LebelShirt, setLebelShirt] = useState(initialStyles.shirt)
    const [LebelVest, setLebelVest] = useState(initialStyles.vest)
    const [LebelShoes, setLebelShoes] = useState(initialStyles.shoes)

    const Resize = useSelector((state) => state.profile.size);
    const navigate = useNavigate()
    const location = useLocation()
    const [activeItem, setActiveItem] = useState(1);

    const toggleItem = (id) => {
        setActiveItem(prevActive => prevActive === id ? null : id);
    };

    const handleBack = () => {
        const currentValues = getValues();
        onBack(currentValues);
    };

    // Modified handleSubmit to save to localStorage only on submit
    const handleFormSubmit = (data) => {
        // Save to localStorage only when submitting
        if (Coatstyle) localStorage.setItem('GroomMencoatStyle', JSON.stringify(Coatstyle));
        if (Pantstyle) localStorage.setItem('GroomMenpantstyle', JSON.stringify(Pantstyle));
        if (Shirtstyle) localStorage.setItem('GroomMenshirtstyle', JSON.stringify(Shirtstyle));
        if (Veststyle) localStorage.setItem('GroomMenVeststyle', JSON.stringify(Veststyle));
        if (Shoesstyle) localStorage.setItem('GroomMenshoestyle', JSON.stringify(Shoesstyle));

        onNext(data);
    };

    const ViewState = async () => {
        try {
            const api = `all-inventories?size=${1000}`;
            const response = await get(api);
            if (response?.status == true) {
                setdata(response.data?.rows);

                const savedStyles = getInitialStyleState();
                if (savedStyles.coat) {
                    setValue("GroomMenCoat", savedStyles.coat.style);
                    setValue("GroomMencoatinventory_id", savedStyles.coat.id);
                    // Find the full item data from loaded data to get description
                    const fullCoatData = response.data?.rows.find(item => item.id === savedStyles.coat.id);
                    if (fullCoatData) {
                        setCoatstyle(fullCoatData);
                        setLebelCoat(fullCoatData);
                    }
                }
                if (savedStyles.pant) {
                    setValue("GroomMenPant", savedStyles.pant.style);
                    setValue("GroomMenPaintinventory_id", savedStyles.pant.id);
                    const fullPantData = response.data?.rows.find(item => item.id === savedStyles.pant.id);
                    if (fullPantData) {
                        setPantstyle(fullPantData);
                        setLebelpant(fullPantData);
                    }
                }
                if (savedStyles.shirt) {
                    setValue("GroomMenShirt", savedStyles.shirt.style);
                    setValue("GroomMenshirtInventory_id", savedStyles.shirt.id);
                    const fullShirtData = response.data?.rows.find(item => item.id === savedStyles.shirt.id);
                    if (fullShirtData) {
                        setShirtstyle(fullShirtData);
                        setLebelShirt(fullShirtData);
                    }
                }
                if (savedStyles.vest) {
                    setValue("GroomMenVest", savedStyles.vest.style);
                    setValue("GroomMenVestInventory_id", savedStyles.vest.id);
                    const fullVestData = response.data?.rows.find(item => item.id === savedStyles.vest.id);
                    if (fullVestData) {
                        setVeststyle(fullVestData);
                        setLebelVest(fullVestData);
                    }
                }
                if (savedStyles.shoes) {
                    setValue("GroomMenShoes", savedStyles.shoes.style);
                    setValue("GroomMenShoesInventory_id", savedStyles.shoes.id);
                    const fullShoesData = response.data?.rows.find(item => item.id === savedStyles.shoes.id);
                    if (fullShoesData) {
                        setShoesstyle(fullShoesData);
                        setLebelShoes(fullShoesData);
                    }
                }
            }
        } catch (err) {
            if (err?.message == "Invalid or expired token" || err?.message == "Invalid Token") {
                localStorage.removeItem('token');
                navigate('/login');
            }
            console.error('Errordsfdsfd:', err);
        } finally {
        }
    };

    useEffect(() => {
        ViewState();
    }, []);

    // First filter all the data
    const category1Data = data?.filter((item) => item.category_id === 1);
    const pants = data?.filter((item) => item.category_id === 2);
    const Shirt = data?.filter((item) => item.category_id === 3);
    const Vest = data?.filter((item) => item.category_id === 4);
    const Tie = data?.filter((item) => item.category_id === 5);
    const Shoes = data?.filter((item) => item.category_id === 7);
    const Pocket = data?.filter((item) => item.category_id === 8);
    const Jewelry = data?.filter((item) => item.category_id === 9);

    // Then create options from filtered data
    const options = category1Data.map(item => ({
        value: item.style,
        label: `${item.style} ${item.description}`
    }));

    // Now create sorted versions
    const sortedOptions = [...options].sort((a, b) => a.label.localeCompare(b.label, undefined, { numeric: true }));
    const sortedPants = [...pants].sort((a, b) =>
        a.style.localeCompare(b.style, undefined, { numeric: true })
    );
    const sortedShirts = [...Shirt].sort((a, b) =>
        a.style.localeCompare(b.style, undefined, { numeric: true })
    );
    const sortedVest = [...Vest].sort((a, b) =>
        a.style.localeCompare(b.style, undefined, { numeric: true })
    );
    const sortedTie = [...Tie].sort((a, b) =>
        a.style.localeCompare(b.style, undefined, { numeric: true })
    );
    const sortedPocketSquare = [...Pocket].sort((a, b) =>
        a.style.localeCompare(b.style, undefined, { numeric: true })
    );
    const sortedJewelry = [...Jewelry].sort((a, b) =>
        a.style.localeCompare(b.style, undefined, { numeric: true })
    );
    const sortedShoes = [...Shoes].sort((a, b) =>
        a.style.localeCompare(b.style, undefined, { numeric: true })
    );

    const customComponents = {
        DropdownIndicator: (props) => (
            <div {...props} style={{ padding: "5px", display: "flex", alignItems: "center" }}>
                <Search size={16} />
            </div>
        ),
    };

    const handlejwellaryChange = (selectedOption) => {
        const selectedValue = selectedOption ? selectedOption.value : '';
        const selectedStyle = Jewelry.find(item => item.style === selectedValue);
        if (selectedStyle) {
            setValue("GroomMenjewelryinventory_id", selectedStyle.id);
        } else {
            setValue("GroomMenjewelryinventory_id", "");
            setValue("GroomMenJewelry", "");
        }
    }

    const handleTie = (selectedOption) => {
        const selectedValue = selectedOption ? selectedOption.value : '';
        const selectedStyle = Tie.find(item => item.style == selectedValue);
        if (selectedStyle) {
            setValue("GroomMenTieInventory_id", selectedStyle.id);
        } else {
            setValue("GroomMenTieInventory_id", "");
            setValue("GroomMenTie", "");
        }
    }

    const handlePocket = (selectedOption) => {
        const selectedValue = selectedOption ? selectedOption.value : '';
        const selectedStyle = Pocket.find(item => `${item.style}` == selectedValue);

        if (selectedStyle) {
            setValue("GroomMenPocketInventory_id", selectedStyle.id);
            setValue("GroomMenPocket", selectedValue, { shouldValidate: true });
        } else {
            setValue("GroomMenPocketInventory_id", "");
            setValue("GroomMenPocket", "");
        }
    };

    const handleCoatChange = (selectedOption) => {
        if (selectedOption) {
            const selectedStyle = category1Data.find(item => item.style === selectedOption.value);
            setValue("GroomMencoatinventory_id", selectedStyle.id);
            setCoatstyle(selectedStyle);
            setSelectedCoatStyleForPants(selectedStyle.style);
            setLebelCoat(selectedStyle);
        } else {
            setCoatstyle(null);
            setValue("GroomMencoatinventory_id", "");
            setSelectedCoatStyleForPants(null);
            setLebelCoat(null);
        }
    };

    const handlePaintChange = (selectedOption) => {
        const selectedValue = selectedOption ? selectedOption.value : '';
        const selectedStyle = pants.find(item => `${item.style}` == selectedValue);

        if (selectedStyle) {
            setValue("GroomMenPaintinventory_id", selectedStyle.id);
            setPantstyle(selectedStyle);
            setValue("GroomMenPant", selectedValue, { shouldValidate: true });
            setLebelpant(selectedStyle);
        } else {
            setValue("GroomMenPaintinventory_id", "");
            setPantstyle(null);
            setLebelpant(null);
        }
    };

    const handleShirtChange = (selectedOption) => {
        const selectedValue = selectedOption ? selectedOption.value : '';
        const selectedShirt = sortedShirts.find(item => `${item.style}` == selectedValue);

        if (selectedShirt) {
            setValue("GroomMenshirtInventory_id", selectedShirt.id);
            setShirtstyle(selectedShirt)
            setValue("GroomMenShirt", selectedValue, { shouldValidate: true });
            setLebelShirt(selectedShirt);
        } else {
            setValue("GroomMenshirtInventory_id", "");
            setValue("GroomMenShirt", "");
            setShirtstyle(null)
            setLebelShirt(null);
        }
    };

    const handleVestChange = (selectedOption) => {
        const selectedValue = selectedOption ? selectedOption.value : '';
        const selectedStyle = Vest.find(item => item.style == selectedValue) || null;
        if (selectedStyle) {
            setValue("GroomMenVestInventory_id", selectedStyle.id);
            setVeststyle(selectedStyle);
            setValue("GroomMenVest", selectedValue, { shouldValidate: true });
            setLebelVest(selectedStyle);
        } else {
            setValue("GroomMenVest", "");
            setValue("GroomMenVestInventory_id", "");
            setVeststyle(null);
            setLebelVest(null);
        }
    };

    const handleShoes = (selectedOption) => {
        const selectedValue = selectedOption ? selectedOption.value : '';
        const selectedStyle = Shoes.find(item => `${item.style}` == selectedValue);

        if (selectedStyle) {
            setValue("GroomMenShoesInventory_id", selectedStyle.id);
            setShoesstyle(selectedStyle)
            setValue("GroomMenShoes", selectedValue, { shouldValidate: true });
            setLebelShoes(selectedStyle);
        } else {
            setValue("GroomMenShoesInventory_id", "");
            setValue("GroomMenShoes", "");
            setShoesstyle("")
            setLebelShoes(null);
        }
    };

    const fetchInventoryDatatwi = async () => {
        try {
            const api = `all-inventory-categories`;
            const totalData = await get(api);
        } catch (err) {
            if (err?.message == "Invalid or expired token" || err?.message == "Invalid Token") {
                localStorage.removeItem('token');
                navigate('/login');
            }
        } finally {
        }
    };

    useEffect(() => {
        fetchInventoryDatatwi()
    }, [])

    const AccordionItem = ({ id, title, children }) => {
        const [isHovered, setIsHovered] = useState(false);
        const isActive = activeItem === id;

        return (
            <div className="accordion-item">
                <button
                    className={`accordion-button ${isActive ? 'active' : ''}`}
                    onClick={() => toggleItem(id)}
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                >
                    <span>{title}</span>
                    <span className="accordion-icon">{isActive ? <em class="icon ni ni-upword-ios"></em> : <em class="icon ni ni-downward-ios"></em>}</span>
                </button>
                {isActive && <div className="accordion-content">{children}</div>}
            </div>
        );
    };

    useEffect(() => {
        if (activeItem != 1) {
            setLebelCoat(Coatstyle)
        }
        if (activeItem != 2) {
            setLebelpant(Pantstyle)
        }
        if (activeItem != 3) {
            setLebelShirt(Shirtstyle)
        }
        if (activeItem != 4) {
            setLebelVest(Veststyle)
        }
        if (activeItem != 6) {
            setLebelShoes(Shoesstyle)
        }
    }, [activeItem])

    const getSortedPantsOptions = () => {
        const baseOptions = sortedPants.map(item => {
            const isExact = item.style === selectedCoatStyleForPants;
            const isPartial = item.style.includes(selectedCoatStyleForPants);

            return {
                value: item.style,
                label: (
                    <span style={{ fontWeight: isExact || isPartial ? 'bold' : 'normal' }}>
                        {item.style} {item.description}
                    </span>
                ),
                sortValue: item.style, // for sorting fallback
                isExact,
                isPartial
            };
        });

        // Sorting: Exact match > Partial match > Nearest higher > Others
        const sorted = baseOptions.sort((a, b) => {
            if (a.isExact) return -1;
            if (b.isExact) return 1;
            if (a.isPartial && !b.isPartial) return -1;
            if (!a.isPartial && b.isPartial) return 1;

            const selected = parseInt(selectedCoatStyleForPants);
            const aStyle = parseInt(a.sortValue);
            const bStyle = parseInt(b.sortValue);

            // Put nearest higher style (like 130 after 125) earlier
            const aDiff = aStyle > selected ? aStyle - selected : Infinity;
            const bDiff = bStyle > selected ? bStyle - selected : Infinity;

            return aDiff - bDiff;
        });

        return sorted;
    };

    return (
        <Container>
            <div class="nk-content ">
                <div class="container-fluid">
                    <div class="nk-content-inner">
                        <div class="nk-content-body">
                            <div class="nk-block-head nk-block-head-sm">
                                <div class="nk-block-between">
                                    <div class="nk-block-head-content">
                                        <h3 class="nk-block-title page-title">{location.pathname == "/add-wedding-order" ? "Add" : "Update"}  Weddings Event {(ticket && location.pathname != "/add-order") && `#${ticket}`}</h3></div>

                                </div>
                            </div>

                            <div class="card card-full">
                                <div class="card-inner">
                                    <div class="stepperLeft">
                                        <div className="row">
                                            <div className="col-md-4 brIght">
                                                <section className="section1">
                                                    <header>
                                                        <div className="bead complete"><span><i class="fa-solid fa-check"></i></span></div> {location.pathname == "/add-wedding-order" ? "Add" : "Update"}  Groom's Detail
                                                    </header>
                                                </section>
                                                <section className="section2">
                                                    <header>
                                                        <div className="bead complete"><span><i class="fa-solid fa-check"></i></span></div>{location.pathname == "/add-wedding-order" ? "Add" : "Update"}  Bride's Detail
                                                    </header>
                                                </section>
                                                <section className="section2">
                                                    <header>
                                                        <div className="bead current"><span><i class="fa-solid fa-check"></i></span></div>{location.pathname == "/add-wedding-order" ? "Add" : "Update"} Groom's Style Detail
                                                    </header>
                                                </section>
                                                <section className="section2">
                                                    <header>
                                                        <div className="bead current"><span>4</span></div>{location.pathname == "/add-wedding-order" ? "Add" : "Update"} Groomsmen Style Detail
                                                    </header>
                                                </section>
                                                <section>
                                                    <header>
                                                        <div className="bead"><span>5</span></div> {location.pathname == "/add-wedding-order" ? "Add" : "Update"} Notes
                                                    </header>
                                                </section>
                                            </div>

                                            <div className="col-md-8">
                                                <div className="row">
                                                    <div className="d-flex align-items-center justify-content-between w-100 ">
                                                        <h4>{location.pathname == "/add-wedding-order" ? "Add" : "Update"} Groomsmen Style Detail</h4>
                                                    </div></div>
                                                {/* Changed to handleFormSubmit */}
                                                <form onSubmit={handleSubmit(handleFormSubmit)}>
                                                    <div className="inputCardBox mt-4">
                                                        <div className="col-md-12">
                                                            <div className="newAccordion">
                                                                <div className={"accordionContainer"}>

                                                                    <AccordionItem
                                                                        id={1}
                                                                        title={
                                                                            LebelCoat?.style ? (
                                                                                <span className="fw-400">
                                                                                    <strong className="fw-700">Coat Style</strong> ({LebelCoat?.style} {LebelCoat?.description})
                                                                                </span>
                                                                            ) : (
                                                                                <span><strong className="fw-700">Coat Style</strong></span>
                                                                            )
                                                                        }
                                                                    >
                                                                        <div className="accordion-inner">
                                                                            <div className="row">
                                                                                <div className="col-md-8 p-0 stateSelect">
                                                                                    <div className="row">
                                                                                        <div className="col-md-6 mb-3">
                                                                                            <label>Coat Style<span className="text-red-500"></span></label>
                                                                                            <Controller
                                                                                                name="GroomMenCoat"
                                                                                                control={control}
                                                                                                render={({ field }) => (
                                                                                                    <Select
                                                                                                        {...field}
                                                                                                        options={sortedOptions}
                                                                                                        placeholder="Select"
                                                                                                        components={customComponents}
                                                                                                        isClearable
                                                                                                        onChange={(selectedOption) => {
                                                                                                            field.onChange(selectedOption ? selectedOption.value : '');
                                                                                                            handleCoatChange(selectedOption);
                                                                                                        }}
                                                                                                        value={options.find(option => option.value === field.value) || null}
                                                                                                    />
                                                                                                )}
                                                                                            />
                                                                                            {errors.GroomMenCoat && <p className='red'>{errors.GroomMenCoat.message}</p>}
                                                                                        </div>
                                                                                        <div className="col-md-6 mb-3">
                                                                                            <h6 className="mb-0 mt-1">{Coatstyle?.style ? `#${Coatstyle.style} ` : ''}</h6>
                                                                                            <p className="coatTxtPra"><small>{Coatstyle?.description}</small></p>
                                                                                        </div>
                                                                                    </div >
                                                                                </div >

                                                                                <div className="col-md-4 addStyleMobileImg">
                                                                                    {Coatstyle?.image ? (
                                                                                        <Image src={`${ImageUrl}${Coatstyle?.image}`} className="noSelectCoatImg" alt="" />
                                                                                    ) : (
                                                                                        <img src="/assets/images/no-photo.png" className="selectCoatImg" alt="" />
                                                                                    )}
                                                                                </div>
                                                                            </div >
                                                                        </div >
                                                                    </AccordionItem>
                                                                    <AccordionItem
                                                                        id={2}
                                                                        title={
                                                                            Lebelpant?.style ? (
                                                                                <span className="fw-400">
                                                                                    <strong className="fw-700">Pant Style</strong> ({Lebelpant?.style} {Lebelpant?.description})
                                                                                </span>
                                                                            ) : (
                                                                                <span><strong className="fw-700">Pant Style</strong></span>
                                                                            )
                                                                        }
                                                                    >
                                                                        <div className="accordion-inner">
                                                                            <div className="row">
                                                                                <div className="col-md-8 p-0 stateSelect">
                                                                                    <div className="row">
                                                                                        <div className="col-md-6 mb-3">
                                                                                            <label>Pant Style<span className="text-red-500"></span></label>
                                                                                            <Controller
                                                                                                name="GroomMenPant"
                                                                                                control={control}
                                                                                                render={({ field }) => (
                                                                                                    <Select
                                                                                                        {...field}
                                                                                                        options={getSortedPantsOptions()}
                                                                                                        placeholder="Select"
                                                                                                        components={customComponents}
                                                                                                        isClearable
                                                                                                        onChange={(selectedOption) => {
                                                                                                            const selectedValue = selectedOption ? selectedOption.value : '';
                                                                                                            field.onChange(selectedValue);
                                                                                                            handlePaintChange(selectedOption);
                                                                                                        }}
                                                                                                        value={getSortedPantsOptions().find(option => option.value === field.value) || null}
                                                                                                    />
                                                                                                )}
                                                                                            />
                                                                                            {errors.GroomMenPant && <p className='red'>{errors.GroomMenPant.message}</p>}
                                                                                        </div>

                                                                                        <div className="col-md-6 mb-3">
                                                                                            <h6 className="mb-0 mt-1">{Pantstyle?.style ? `#${Pantstyle.style}` : ''}</h6>
                                                                                            <p className="coatTxtPra"><small>{Pantstyle?.description}</small></p>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-md-4 addStyleMobileImg">
                                                                                    {Pantstyle?.image ? (
                                                                                        <Image src={`${ImageUrl}${Pantstyle?.image}`} className="noSelectCoatImg" alt="" />
                                                                                    ) : (
                                                                                        <img src="/assets/images/no-photo.png" className="selectCoatImg" alt="" />
                                                                                    )}
                                                                                </div>

                                                                            </div>
                                                                        </div>
                                                                    </AccordionItem>
                                                                    <AccordionItem
                                                                        id={3}
                                                                        title={
                                                                            LebelShirt?.style ? (
                                                                                <span className="fw-400">
                                                                                    <strong className="fw-700">Shirt Style</strong> ({LebelShirt?.style} {LebelShirt?.description})
                                                                                </span>
                                                                            ) : (
                                                                                <span><strong className="fw-700">Shirt Style</strong></span>
                                                                            )
                                                                        }
                                                                    >
                                                                        <div class="accordion-inner">
                                                                            <div className="row">
                                                                                <div className="col-md-8 p-0 stateSelect">
                                                                                    <div className="row">
                                                                                        <div className="col-md-6 mb-3">
                                                                                            <label>Shirt Style<span className="text-red-500"></span></label>
                                                                                            <Controller
                                                                                                name="GroomMenShirt"
                                                                                                control={control}
                                                                                                render={({ field }) => (
                                                                                                    <Select
                                                                                                        {...field}
                                                                                                        options={sortedShirts.map(item => ({
                                                                                                            value: `${item.style}`,
                                                                                                            label: `${item.style} ${item.description}`
                                                                                                        }))}
                                                                                                        placeholder="Select"
                                                                                                        components={customComponents}
                                                                                                        isClearable
                                                                                                        onChange={(selectedOption) => {
                                                                                                            const selectedValue = selectedOption ? selectedOption.value : '';
                                                                                                            field.onChange(selectedValue);
                                                                                                            handleShirtChange(selectedOption);
                                                                                                        }}
                                                                                                        value={sortedShirts.map(item => ({
                                                                                                            value: `${item.style}`,
                                                                                                            label: `${item.style} ${item.description}`
                                                                                                        })).find(option => option.value === field.value) || null}
                                                                                                    />
                                                                                                )}
                                                                                            />
                                                                                            {errors.GroomMenShirt && <p className='red'>{errors.GroomMenShirt.message}</p>}
                                                                                        </div>
                                                                                        <div className="col-md-6 mb-3">
                                                                                            <h6 className="mb-0 mt-1">{Shirtstyle?.style ? `#${Shirtstyle?.style}` : ''}</h6>
                                                                                            <p className="coatTxtPra"><small>{Shirtstyle?.description}</small></p>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-md-4 addStyleMobileImg">
                                                                                    {
                                                                                        Shirtstyle?.image ? <Image src={`${ImageUrl}${Shirtstyle?.image}`} className="noSelectCoatImg" alt="" />
                                                                                            : <img src="/assets/images/no-photo.png" className="selectCoatImg" alt />
                                                                                    }
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                    </AccordionItem>
                                                                    <AccordionItem
                                                                        id={4}
                                                                        title={
                                                                            LebelVest?.style ? (
                                                                                <span className="fw-400">
                                                                                    <strong className="fw-700">Vest Style</strong> ({LebelVest?.style} {LebelVest?.description})
                                                                                </span>
                                                                            ) : (
                                                                                <span><strong className="fw-700">Vest Style</strong></span>
                                                                            )
                                                                        }
                                                                    >
                                                                        <div class="accordion-inner">
                                                                            <div className="row">
                                                                                <div className="col-md-12 p-0 stateSelect">
                                                                                    <div className="row">
                                                                                        <div className="col-md-8 mb-3">
                                                                                            <div className="row">
                                                                                                <div className="col-md-6 mb-3">
                                                                                                    <label>Vest Style <span className="text-red-500"></span></label>
                                                                                                    <Controller
                                                                                                        name="GroomMenVest"
                                                                                                        control={control}
                                                                                                        render={({ field }) => (
                                                                                                            <Select
                                                                                                                {...field}
                                                                                                                options={sortedVest.map(item => ({
                                                                                                                    value: item.style,
                                                                                                                    label: `${item.style} ${item.description}`
                                                                                                                }))}
                                                                                                                placeholder="Select"
                                                                                                                components={customComponents}
                                                                                                                isClearable
                                                                                                                onChange={(selectedOption) => {
                                                                                                                    field.onChange(selectedOption ? selectedOption.value : '');
                                                                                                                    handleVestChange(selectedOption);
                                                                                                                }}
                                                                                                                value={sortedVest.map(item => ({
                                                                                                                    value: item.style,
                                                                                                                    label: `${item.style} ${item.description}`
                                                                                                                })).find(option => option.value === field.value) || null}
                                                                                                            />
                                                                                                        )}
                                                                                                    />
                                                                                                    {errors.GroomMenVest && <p className='red'>{errors.GroomMenVest.message}</p>}
                                                                                                </div>

                                                                                                <div className="col-md-6 mb-3">
                                                                                                    <h6 className="mb-0 mt-1">{Veststyle?.style ? `#${Veststyle?.style}` : ''}</h6>
                                                                                                    <p className="coatTxtPra"><small>{Veststyle?.description}</small></p>
                                                                                                </div>

                                                                                            </div>
                                                                                        </div>

                                                                                        <div className="col-md-4 addStyleMobileImg">
                                                                                            {
                                                                                                Veststyle?.image ? <Image src={`${ImageUrl}${Veststyle?.image}`} className="noSelectCoatImg" alt="" />
                                                                                                    : <img src="/assets/images/no-photo.png" className="selectCoatImg" alt />
                                                                                            }
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </AccordionItem>
                                                                    <AccordionItem
                                                                        id={5}
                                                                        title={<span><strong className="fw-700">Tie, Pocket, Jewelry</strong></span>}
                                                                    >
                                                                        <div className="accordion-inner">
                                                                            <div className="row">
                                                                                <div className="col-md-12 p-0 stateSelect">
                                                                                    <div className="row">
                                                                                        <div className="col-md-6 mb-3">
                                                                                            <label>Tie <span className="text-red-500"></span></label>
                                                                                            <Controller
                                                                                                name="GroomMenTie"
                                                                                                control={control}
                                                                                                render={({ field }) => (
                                                                                                    <Select
                                                                                                        {...field}
                                                                                                        options={sortedTie.map(item => ({
                                                                                                            value: item.style,
                                                                                                            label: `${item.style} ${item.description}`
                                                                                                        }))}
                                                                                                        placeholder="Select Tie"
                                                                                                        components={customComponents}
                                                                                                        isClearable
                                                                                                        onChange={(selectedOption) => {
                                                                                                            field.onChange(selectedOption ? selectedOption.value : '');
                                                                                                            handleTie(selectedOption);
                                                                                                        }}
                                                                                                        value={sortedTie.map(item => ({
                                                                                                            value: item.style,
                                                                                                            label: `${item.style} ${item.description}`
                                                                                                        })).find(option => option.value === field.value) || null}
                                                                                                    />
                                                                                                )}
                                                                                            />
                                                                                            {errors.GroomMenTie && <p className='red'>{errors.GroomMenTie.message}</p>}
                                                                                        </div>

                                                                                        <div className="col-md-6 mb-3">
                                                                                            <label>Pocket Square <span className="text-red-500"></span></label>
                                                                                            <Controller
                                                                                                name="GroomMenPocket"
                                                                                                control={control}
                                                                                                render={({ field }) => (
                                                                                                    <Select
                                                                                                        {...field}
                                                                                                        options={sortedPocketSquare.map(item => ({
                                                                                                            value: `${item.style}`,
                                                                                                            label: `${item.style} ${item.description}`
                                                                                                        }))}
                                                                                                        placeholder="Select Pocket Square"
                                                                                                        components={customComponents}
                                                                                                        isClearable
                                                                                                        onChange={(selectedOption) => {
                                                                                                            field.onChange(selectedOption ? selectedOption.value : '');
                                                                                                            handlePocket(selectedOption);
                                                                                                        }}
                                                                                                        value={sortedPocketSquare.map(item => ({
                                                                                                            value: `${item.style}`,
                                                                                                            label: `${item.style} ${item.description}`
                                                                                                        })).find(option => option.value === field.value) || null}
                                                                                                    />
                                                                                                )}
                                                                                            />
                                                                                            {errors.GroomMenPocket && <p className='red'>{errors.GroomMenPocket.message}</p>}
                                                                                        </div>

                                                                                        <div className="col-md-6 mb-3">
                                                                                            <label>Jewelry<span className="text-red-500"></span></label>
                                                                                            <Controller
                                                                                                name="GroomMenJewelry"
                                                                                                control={control}
                                                                                                render={({ field }) => (
                                                                                                    <Select
                                                                                                        {...field}
                                                                                                        options={sortedJewelry.map(item => ({
                                                                                                            value: item.style,
                                                                                                            label: `${item.style} ${item.description}`
                                                                                                        }))}
                                                                                                        placeholder="Select Jewelry’"
                                                                                                        components={customComponents}
                                                                                                        isClearable
                                                                                                        onChange={(selectedOption) => {
                                                                                                            field.onChange(selectedOption ? selectedOption.value : '');
                                                                                                            handlejwellaryChange(selectedOption);
                                                                                                        }}
                                                                                                        value={sortedJewelry.map(item => ({
                                                                                                            value: item.style,
                                                                                                            label: `${item.style} ${item.description}`
                                                                                                        })).find(option => option.value === field.value) || null}
                                                                                                    />
                                                                                                )}
                                                                                            />
                                                                                            {errors.GroomMenJewelry && <p className='red'>{errors.GroomMenJewelry.message}</p>}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                    </AccordionItem>
                                                                    <AccordionItem
                                                                        id={6}
                                                                        title={
                                                                            LebelShoes?.style ? (
                                                                                <span className="fw-400">
                                                                                    <strong className="fw-700">Shoe Style</strong> ({LebelShoes?.style} {LebelShoes?.description})
                                                                                </span>
                                                                            ) : (
                                                                                <span><strong className="fw-700">Shoe Style</strong></span>
                                                                            )
                                                                        }
                                                                    >
                                                                        <div className="accordion-inner">
                                                                            <div className="row">
                                                                                <div className="col-md-12 p-0 stateSelect">
                                                                                    <div className="row">
                                                                                        <div className="col-md-8 mb-3">
                                                                                            <div className="row">
                                                                                                <div className="col-md-6 mb-3">
                                                                                                    <label> Shoe Style <span className="text-red-500"></span></label>
                                                                                                    <Controller
                                                                                                        name="GroomMenShoes"
                                                                                                        control={control}
                                                                                                        rules={{ required: false }}
                                                                                                        render={({ field }) => (
                                                                                                            <Select
                                                                                                                {...field}
                                                                                                                options={sortedShoes.map(item => ({
                                                                                                                    value: `${item.style}`,
                                                                                                                    label: `${item.style} ${item.description}`
                                                                                                                }))}
                                                                                                                placeholder="Select shoe"
                                                                                                                components={customComponents}
                                                                                                                isClearable
                                                                                                                onChange={(selectedOption) => {
                                                                                                                    field.onChange(selectedOption ? selectedOption.value : '');
                                                                                                                    handleShoes(selectedOption);
                                                                                                                }}
                                                                                                                value={sortedShoes.map(item => ({
                                                                                                                    value: `${item.style}`,
                                                                                                                    label: `${item.style} ${item.description}`
                                                                                                                })).find(option => option.value === field.value) || null}
                                                                                                            />
                                                                                                        )}
                                                                                                    />
                                                                                                    {errors.GroomMenShoes && <p className='red'>{errors.GroomMenShoes.message}</p>}

                                                                                                </div>
                                                                                                <div className="col-md-6 mb-3">
                                                                                                    <h6 className="mb-0 mt-1">{Shoesstyle?.style ? `#${Shoesstyle?.style}` : ''}</h6>
                                                                                                    <p className="coatTxtPra"><small>{Shoesstyle?.description}</small></p>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="col-md-4 addStyleMobileImg">
                                                                                            {
                                                                                                Shoesstyle?.image ? <Image src={`${ImageUrl}${Shoesstyle?.image}`} className="noSelectCoatImg" alt="" />
                                                                                                    : <img src="/assets/images/no-photo.png" className="selectCoatImg" alt />
                                                                                            }
                                                                                        </div></div></div>
                                                                            </div>
                                                                        </div>
                                                                    </AccordionItem>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-12">
                                                            <div className="row">
                                                                <div class="col-md-12 mt-3">
                                                                    <a className="backBtnWedding" style={{ cursor: "pointer" }} onClick={handleBack}>Back</a>
                                                                    <button
                                                                        type="submit"
                                                                        className="addBtnCustomer"
                                                                    >
                                                                        Continue
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div >
                                                </form >
                                            </div >
                                        </div >
                                    </div >
                                </div >
                            </div >
                        </div >
                    </div >
                </div >
            </div >

        </Container >
    )
}

export default GroomsmenStyleDetail;